/**
 * The paid /kb landing page variants — one self-contained `<variant>.json` here,
 * one route file under src/routes/kb. Adding one adds it to the prerender list.
 *
 * Dependency-free so the SSG script can import it without pulling in React or
 * the SVG assets `kb.ts` needs.
 */
export const KB_VARIANTS = ['a', 'c'] as const;

export type KbVariantType = (typeof KB_VARIANTS)[number];
